import { Color, IntersectionTests, ScreenSpaceEventType, } from "cesium";
import { EarthBrainUtils } from "./earthbrainutility";
import { ViewerCamera } from "../viewers/viewer-camera";
export class CesiumPicker {
    _viewer;
    _preview;
    _handler;
    _spheres;
    _onReject;
    constructor(viewer, preview, handler) {
        this._viewer = viewer;
        this._preview = preview;
        this._handler = handler;
        this._spheres = [];
    }
    async _resolvePoint(mousePos, selector) {
        // セレクタが指定された場合はその選択戦略（例: 点群優先）を使う。
        if (selector) {
            return selector.getPointOnMousePos(mousePos);
        }
        return this.getPointOnMousePos(mousePos);
    }
    async pickPoint(selector) {
        return new Promise((resolve, reject) => {
            this._handler.setInputAction(async ({ position }) => {
                const point = await this._resolvePoint(position, selector);
                this._handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
                if (point) {
                    resolve(point);
                }
                else {
                    reject("Point is not Selected");
                }
            }, ScreenSpaceEventType.LEFT_CLICK);
        });
    }
    pickNumberOfPoints(numberOfPointsToPick, selector) {
        return new Promise(async (resolve, reject) => {
            this._onReject = reject;
            const result = [];
            this._preview.setSphereVisibility(true);
            this._handler.setInputAction(async ({ endPosition }) => {
                const point = await this._resolvePoint(endPosition, selector);
                if (point) {
                    this._preview.setSpherePosition(point);
                    this._viewer.scene.requestRender();
                }
            }, ScreenSpaceEventType.MOUSE_MOVE);
            while (result.length !== numberOfPointsToPick) {
                try {
                    const point = await this.pickPoint(selector);
                    result.push(point);
                    this._spheres.push(EarthBrainUtils.addSphere(this._viewer, point, Color.CRIMSON));
                }
                catch {
                    console.log("Point could not be picked, Please try again");
                }
            }
            this._handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
            this._preview.setSphereVisibility(false);
            this._spheres.forEach((s) => this._viewer.entities.remove(s));
            // this._viewer.scene.requestRender();
            resolve(result);
        });
    }
    abortPickPoint(msg) {
        this._handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
        this._handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
        this._preview.setSphereVisibility(false);
        this._spheres.forEach((s) => this._viewer.entities.remove(s));
        // this._viewer.scene.requestRender();
        this._onReject && this._onReject(msg);
    }
    getPointOnMousePos(mousePos, onlyTerrain = false) {
        try {
            const pickResult = this._viewer.scene.pick(mousePos);
            if (onlyTerrain && pickResult.id?.pickInfo?.pickableType) {
                return undefined;
            }
            else {
                return this._viewer.scene.pickPosition(mousePos);
            }
        }
        catch (e) {
            return undefined;
        }
    }
    getPointAtPlaneOnMousePos(mousePos, plane) {
        try {
            const ray = ViewerCamera.getInstance(this._viewer).getPickRay(mousePos);
            if (ray) {
                return IntersectionTests.rayPlane(ray, plane);
            }
            return undefined;
        }
        catch (e) {
            return undefined;
        }
    }
    // picks the hovered Item
    getRenderedEntity(mousePos) {
        const entity = this._viewer.scene.pick(mousePos);
        if (entity && entity.id) {
            return entity.id;
        }
    }
    //picks the one which has allow Picking true
    getPickablePickedInfo(mousePos) {
        let pickedInfo = undefined;
        // Picking should happen based on entity
        const pickedPrimitives = this._viewer.scene.drillPick(mousePos);
        for (let i = 0; i < pickedPrimitives.length; i++) {
            if (pickedPrimitives[i].id) {
                if (pickedPrimitives[i].id.allowPicking !== undefined &&
                    pickedPrimitives[i].id.allowPicking === false) {
                    continue;
                }
                if (pickedPrimitives[i].id.pickInfo) {
                    pickedInfo = pickedPrimitives[i].id.pickInfo;
                    break;
                }
            }
        }
        return pickedInfo;
    }
    getAllowPickedEntity(mousePos) {
        // Picking should happen based on entity
        const pickedPrimitives = this._viewer.scene.drillPick(mousePos);
        for (let i = 0; i < pickedPrimitives.length; i++) {
            if (pickedPrimitives[i].id) {
                if (pickedPrimitives[i].id.allowPicking !== undefined &&
                    pickedPrimitives[i].id.allowPicking === false) {
                    continue;
                }
                return pickedPrimitives[i].id;
            }
        }
    }
    getOnlyFromPickable(mousePos, type) {
        let pickedInfo = undefined;
        // Picking should happen based on entity
        const pickedPrimitives = this._viewer.scene.drillPick(mousePos);
        for (let i = 0; i < pickedPrimitives.length; i++) {
            if (pickedPrimitives[i].id) {
                if (pickedPrimitives[i].id.allowPicking !== undefined &&
                    pickedPrimitives[i].id.allowPicking === false) {
                    continue;
                }
                pickedInfo = pickedPrimitives[i].id.pickInfo;
                if (pickedInfo.pickableType === type) {
                    pickedInfo = pickedPrimitives[i].id;
                    break;
                }
            }
        }
        return pickedInfo;
    }
    getPickRay(mousePos) {
        return ViewerCamera.getInstance(this._viewer).getPickRay(mousePos);
    }
}
//# sourceMappingURL=cesium-picker.js.map